<template>
  <div class="memberCenter_wrap ChangeInform" :style="{ height: height }">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><router-link to="/MemberCenter">首页</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>上传发票</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">基本信息</div>
      <div>
        <el-form :inline="true" :model="contractData" class="form_table el-form form_table1" ref="form" :inline-message="true">
          <el-form-item label="甲方名称">
            <span>{{ contractData.CompanyName }}</span>
          </el-form-item>
          <el-form-item label="合同编号">
            <span>{{ contractData.ContractNumber }}</span>
          </el-form-item>
          <el-form-item label="合同总价（元）">
            <span>{{ contractData.ContractFee }}</span>
          </el-form-item>
          <el-form-item label="合同验收日期">
            <span>{{ contractData.AcceptanceDate }}</span>
          </el-form-item>
          <el-form-item label="合同质保金到期日期">
            <span>{{ contractData.WarrantyDate }}</span>
          </el-form-item>
          <el-form-item label="付款比例">
            <span>{{ contractData.PaymentRatio }}</span>
          </el-form-item>
          <el-form-item label="特别说明" class="all_line" prop="Remark">
            <!-- <el-input v-if="isDetail == 'false'" type="textarea" v-model="contractData.Remark"></el-input>
            <span v-else>{{ contractData.Remark }}</span> -->
            <span style="color: red; font-size: large; font-weight: bolder"
              >提交质保金请款流程不代表已满足质保金支付条件，具体仍以合同为准，待满足支付条件，广电计量将正常支付款项。</span
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="title">设备概况</div>

      <el-table :data="instrumentList" class="table_wrap1">
        <el-table-column label="计划编号" prop="PlanCode" align="center"></el-table-column>
        <el-table-column label="货物名称" prop="SupplierInstrumentName" align="center"></el-table-column>
        <el-table-column label="规格型号" prop="SupplierSpecification" align="center"></el-table-column>
        <el-table-column label="品牌" prop="Trademark" align="center"></el-table-column>
        <el-table-column label="数量" prop="Count" align="center"></el-table-column>
        <el-table-column label="单价" prop="Price" align="center"></el-table-column>
        <el-table-column label="总价" prop="Total" align="center"></el-table-column>
        <el-table-column label="货期（自然日）" prop="DeliveryTerm" align="center">
          <template slot-scope="sc">
            <span>合同签订后{{ sc.row.DeliveryTerm }}个自然日内</span>
          </template>
        </el-table-column>
        <el-table-column label="安装调试所需日期" prop="TestCycle" align="center">
          <template slot-scope="sc">
            <span>到货后{{ sc.row.TestCycle }}个自然日内</span>
          </template>
        </el-table-column>
        <el-table-column label="保修期限" prop="WarrantyPeriod" align="center"></el-table-column>
      </el-table>

      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" @click="fnGoBack()">返回</span>
        <span v-if="isDetail == 'false'" class="btn_1" @click="fnSave()">提交</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contractId: this.$route.query.contractId,
      autoId: this.$route.query.autoId,
      isDetail: this.$route.query.isDetail,

      contractData: {},
      instrumentList: [],
      height: '0px'
    }
  },

  mounted() {
    let change_inform = document.getElementsByClassName('MemberHeader')[0]
    this.height = window.innerHeight - change_inform.clientHeight - 17 + 'px'
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          contractId: this.contractId,
          autoId: this.autoId,
          isDetail: this.isDetail
        }
      }
      this.getRequest('/Contract/GetRetentionPaymentData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.contractData = res.data.contractData
          this.instrumentList = res.data.instrumentList
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnGoBack() {
      window.close()
    },

    fnSave() {
      this.postRequest('/Contract/SaveRetentionPaymentData', {
        contractId: this.contractId,
        retentionPaymentDataJson: JSON.stringify(this.contractData)
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.$message.success('提交成功')
          window.close()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;
  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}
.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;
    .el-input {
      width: 200px;
    }
  }
  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }
  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }
  .el-input {
    width: 300px;
    margin-right: 8px;
  }
  .businessTermEndDate {
    margin-bottom: 0 !important;
    .el-input {
      width: 100% !important;
    }
    .el-form-item__label:before {
      display: none;
    }
    .el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}
.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;
  .product_form {
    margin-bottom: 0;
  }
}
.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}
.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;
    .el-range-input {
      font-size: 14px;
    }
  }
}
.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;
    .el-tree-node {
      display: inline-block;
    }
  }
}
.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}
.width_full {
  width: 100% !important;
}

.statistics_table {
  width: 98.5%;
  table-layout: fixed;
  th {
    padding: 6px 0;
    text-align: center !important;
    background: #d8eafa !important;
    color: #046663;
    font-weight: normal !important;
    border: 1px solid #95c7f0;
    vertical-align: middle;
    white-space: nowrap;
  }
  td {
    padding: 6px 12px;
    border: 1px solid #95c7f0;
    background: #fff !important;
    text-align: center;
  }
  tr {
    border-bottom: 1px solid #95c7f0;
  }
}
.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form_table1 {
  .el-form-item {
    flex: 33.3%;
  }
  .all_line {
    flex: 0 0 100%;
  }
}
.start {
  vertical-align: middle;
  color: #f56c6c;
  display: inline-block;
  margin-right: 4px;
}
</style>
